import { IUser } from "./user";;
import { IRole } from "./role";

 export interface IProfile {
    user: IUser;
    roles: IRole[];
}
